/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');

export default class ViewModel {
  constructor({
    entityType = 'Ad',
    isFinalURLSuffixEnabled = false,
  } = {}) {
    this.isExpanded = ko.observable(false);

    this.parameters = ko.observableArray();
    this.trackingTemplate = ko.observable();
    this.finalUrlSuffix = ko.observable();

    this.isFinalURLSuffixEnabled = ko.observable(isFinalURLSuffixEnabled);

    this.trackingTemplateShowNone = ko.computed(() => {
      return _.isEmpty(this.trackingTemplate());
    });
    this.finalUrlSuffixShowNone = ko.computed(() => {
      return _.isEmpty(this.finalUrlSuffix());
    });
    this.parametersShowNone = ko.computed(() => {
      return _.isEmpty(this.parameters());
    });

    this.expanderLabel = function() {
      switch (entityType.toLowerCase()) {
      case 'campaign':
        return i18n.get('CampaignUrlOptions_AdvancedSettings_ExpanderLabel');
      case 'adgroup':
        return i18n.get('AdGroupUrlOptions_AdvancedSettings_ExpanderLabel');
      case 'audience':
        return i18n.get('AdvancedUrlOptions_AdvancedSettings_ExpanderLabel');
      case 'ad':
        return i18n.get('AdUrlOptions_AdvancedSettings_ExpanderLabel');
      case 'sitelinksadextension':
      case 'sitelinkadextension':
      case 'sitelink2adextension':
        return i18n.get('SiteLinkUrlOptions_AdvancedSettings_ExpanderLabel');
      case 'actionadextension':
        return i18n.get('ActionUrlOptions_AdvancedSettings_ExpanderLabel');
      case 'priceadextension':
        return i18n.get('AdExtension_Price_Advanced_URL');
      default:
        return i18n.get('UrlOptions_AdvancedSettings_ExpanderLabel');
      }
    };
  }
}
